module.exports = __webpack_public_path__ + "static/img/13.7949b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/13.png
// module id = Sw4T
// module chunks = 0